module.exports = __webpack_public_path__ + "media/img/feature-icon-done-9259f8a4b8d810ccda951e4a2f2ac1e6.svg";